import { useAuthState } from 'react-firebase-hooks/auth';
import { User as FirebaseUser } from 'firebase/auth';
import { auth } from '../firebase';

const useFirebaseAuth = () => {
    return useAuthState(auth) as [FirebaseUser | null, boolean, any];
};

export default useFirebaseAuth;
